import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "arrow"]
  static values = { open: Boolean }

  connect() {
    if (this.openValue) {
      this.menuTarget.classList.remove("hidden")
      this.arrowTarget.classList.add("rotate-90")
    }
  }

  toggle() {
    this.menuTarget.classList.toggle("hidden")
    this.arrowTarget.classList.toggle("rotate-90")
  }
}
